import { sendContactSalesEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class ContactSalesEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendContactSalesEvent;
  protected intercomEventKey = 'contact_sales';

  constructor(settings: { form_source: 'typeform' | 'api'; source?: string }) {
    super();

    try {
      this.eventData = settings;
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
